import React, { memo } from 'react';
import { ChargerMarker } from './charger-marker';
import { ChargerMarkerProps } from './leaflet-map.types';

interface ChargerMarkerListProps {
    locations: ChargerMarkerProps[];
}

function ChargerMarkerList(props: ChargerMarkerListProps) {
    const { locations } = props;

    return (
        <>
            {locations?.map((data: ChargerMarkerProps) => (
                <ChargerMarker key={data.id} {...data} />
            ))}
        </>
    );
}

export default memo(ChargerMarkerList);
